import React, { Component } from 'react';

class TimeSingle extends Component {
    constructor(props){
        super(props);
        let startTime = props.start;
        let stopTime = props.stop;
        let timeArr = [];
        while(startTime <= stopTime){
            let valueType;
            switch(props.valueType){
                case "sec":
                    valueType = parseInt(startTime * (60 * 60), 10);
                break;
                case "msec":
                    valueType = parseInt(startTime * (60 * 60 * 1000), 10);
                break;
                default:
                    valueType = parseInt(startTime, 10);
                break;
            }
            let timeObj = {
                hour: startTime,
                value: valueType
            };
            timeArr.push(timeObj);
            startTime++;
        }
        this.state = {
            timeArr
        };
    }
    
   
    render() {
        const {
            timeArr
        } = this.state;
        const {
            handleOnChange,
            selectedTime,
            isDisabled
        } = this.props;
        
        return (
            <select value={selectedTime} onChange={e => handleOnChange(e.target.value)} disabled={isDisabled}>
                {timeArr.length > 0 && timeArr.map(info => {
                  return <option value={info.value} key={info.hour}>{info.hour}시</option>  
                })}
            </select>
        );
    }
}

export default TimeSingle;


// WEBPACK FOOTER //
// ./src/components/timelist/single.js